import React from 'react'
import { Form, Row, Col } from 'antd'
import { FormikProps, FormikValues } from 'formik'
import { number, object, setLocale, string } from 'yup'

import { InputNumber } from 'src/components/Formik'
import { stringify } from 'src/core/hooks/use-translation'
import SelectOrganizationCurrentManager from 'src/components/Formik/select-organization-current-manager'

function getInitialValues() {
  return {
    organization_id: '',
    request_number: ''
  }
}

function getRenderForm() {
  return (formikProps: FormikProps<FormikValues>) => (
    <Form onSubmit={formikProps.handleSubmit}>
      <Row>
        <Col span={24}>
          <SelectOrganizationCurrentManager
            formikProps={formikProps}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <InputNumber
            dataTestId="request-number-title"
            formikProps={formikProps}
            label="web.reports.parameter.request_number.title"
            min={0}
            name="request_number"
            placeholder="web.reports.parameter.request_number.placeholder"
            required
          />
        </Col>
      </Row>
    </Form>
  )
}

function getValidationSchema() {
  setLocale({
    mixed: {
      notType: 'common.required',
      required: 'common.required'
    }
  })

  return object().shape({
    organization_id: string().required(),
    request_number: number()
      .required()
      .typeError()
      .min(
        1,
        stringify('common.yup.field-min-value', {
          value: 1
        })
      )
  })
}

export { getRenderForm, getValidationSchema, getInitialValues }
